import moment from "moment";
// ⚠ Adjust to where your existing report pages live.
import ZOutReport from "../pages/Reports/ZOutReport";

/**
 * SINGLE source of truth for chatbot reports.
 * Add a report = add one entry here. Menu, typed matching ("z out report"),
 * date form and dialog are all derived from it. No other file changes.
 *
 *  label        — shown in the report list and dialog title
 *  keywords     — extra typed phrases that open it (label is matched automatically,
 *                 also without the word "report": "Z - Out Report" → "z out", "zout")
 *  dateMode     — "single" → params { date }
 *                 "range"  → params { startDate, endDate }
 *                 "none"   → no form, opens straight away, params {}
 *  View         — component shown in the dialog. Props: { params, data }
 *  selfLoading  — true: View fetches by itself (existing page + `embedded` prop)
 *                 false: dialog calls fetchData(params) and passes `data` to View
 *  fetchData    — only when selfLoading is false
 *  Print, printTitle(params), printDate(params) — optional, only when selfLoading is false
 *  subtitle(params) — optional dialog subtitle (default is derived from params)
 */
export const REPORTS = {
  ADMIN_ZOUT_REPORT: {
    label: "Z - Out Report",
    keywords: [],
    dateMode: "single",
    selfLoading: true,
    View: ({ params }) => <ZOutReport embedded date={params.date} />,
  },

  // Example of a range report using the same page pattern:
  // ADMIN_SOME_RANGE_REPORT: {
  //   label: "Some Range Report",
  //   dateMode: "range",
  //   selfLoading: true,
  //   View: ({ params }) => <SomeReport embedded startDate={params.startDate} endDate={params.endDate} />,
  // },
};

// ---------- derived helpers (no need to edit) ----------
const norm = (s = "") => s.toLowerCase().replace(/[^a-z0-9]/g, "");

export const REPORT_OPTIONS = Object.entries(REPORTS).map(([action, r]) => ({ action, label: r.label }));

const fmt = (d) => moment(d, "YYYY-MM-DD").format("MM/DD/YYYY");

export function reportSubtitle(cfg, params = {}) {
  if (cfg.subtitle) return cfg.subtitle(params);
  if (params.date) return fmt(params.date);
  if (params.startDate && params.endDate) return `${fmt(params.startDate)} → ${fmt(params.endDate)}`;
  return "";
}

/** typed text → report action, or null. Longest keyword wins. */
export function matchReport(text = "") {
  const key = norm(text);
  if (!key) return null;
  let best = null;
  for (const [action, r] of Object.entries(REPORTS)) {
    const kws = [norm(r.label), norm(r.label.replace(/report/i, "")), ...(r.keywords || []).map(norm)].filter(Boolean);
    for (const kw of kws) {
      if (key.includes(kw) && (!best || kw.length > best.len)) best = { action, len: kw.length };
    }
  }
  return best?.action ?? null;
}